import { useQueryParams } from '~/hooks/use-query-params/useQueryParams';
import { queryKeys, queryValues } from '~/routes/query-params';
import { POSTHOG_TRACKING_SOURCES } from '~/services/tracking/posthog/constants';
import { usePosthogEvents } from '~/services/tracking/posthog/use-posthog-events/usePosthogEvents';

export const useBrandAndProductDrawer = () => {
  const { deleteQueryParam, setQueryParams, params } = useQueryParams();
  const { trackKgBrandDrawerOpen } = usePosthogEvents();
  const product = params[queryKeys.product];
  const isDrawerOpen =
    params[queryKeys.activeDrawer] === queryValues.brandAndProductDrawer;

  const openDrawer = (product: string) => {
    trackKgBrandDrawerOpen(POSTHOG_TRACKING_SOURCES.ASSET_OVERVIEW);
    setQueryParams({
      [queryKeys.activeDrawer]: queryValues.brandAndProductDrawer,
      [queryKeys.product]: product,
    });
  };

  const closeDrawer = () =>
    deleteQueryParam([queryKeys.activeDrawer, queryKeys.product]);

  return {
    closeDrawer,
    openDrawer,
    isDrawerOpen,
    product,
  };
};
